module.exports = __webpack_public_path__ + "img/16l006-10.55c97924.jpg";